import { useMutation } from 'react-query';
import request from '../../../../helpers/request';
import { deletableCalendarEntityKeys } from '../../shared/configs/calendar';

const paths = {
  [deletableCalendarEntityKeys.day]: 'delete_dates',
  [deletableCalendarEntityKeys.desk]: 'delete_dates_on_desk',
  [deletableCalendarEntityKeys.interval]: 'delete_intervals',
};

const mutationFn = ({ errorMessage, entity, ...props }) =>
  request.delete(`Acceptance/${paths[entity]}`, props, errorMessage, 'Error');

export const useDeleteCalendarIntervals = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
